module.exports = __webpack_public_path__ + "img/top_two@3x.0e4b1080.png";